
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/channels/[id]",
      function () {
        return require("private-next-pages/channels/[id]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/channels/[id]"])
      });
    }
  